// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2nW1U","buttons":"RemoveExpirationActionButtons_buttons__1Ch0v"};